<template>
  <td
    :aria-label="theTitle"
    :class="theClass"
    style="statistic.isrelativestandarderrortoohigh? 'color:red' : ''"
  >
    <template
      v-if="
        statistic.statisticDefinition.se !== null &&
        statistic.value !== undefined &&
        !statistic.isSampleSizeIsTooLow &&
        !statistic.isRelativeStandardErrorTooHigh &&
        !statistic.isRelativeStandardErrorTooHigh &&
        !statistic.value.isMissing
      "
    >
      {{ statistic.formattedSe }}
    </template>
  </td>
</template>

<script>
/* eslint no-unused-vars: 'off' */
import reportModelBuilder from "@/scripts/crossTabulation/reportModelBuilder";
export default {
  props: ["statistic"],
  data: function () {
    var vm = this;
    return {
      theClass: vm.statistic.isRowTotal ? "row-total" : "statistic-cell",
      theTitle: reportModelBuilder.getSeTitle(vm.statistic.apiName),
    };
  },
  methods: {},
};
</script>

<style scoped>
div.statistic-row {
  margin: 0 4px 0 4px;
  white-space: nowrap;
}

td {
  /*display: inline-block;*/
  /*float: left;*/
  /*float: left;*/
  /*margin-left: 10px;*/
  /*background-color: sandybrown;*/
  padding: 0 8px 0 4px;
  /*background-color: ghostwhite;*/
  margin: 2px 4px 2px 4px;
  width: 33px;
}
</style>
